<template>
  <validation-provider
    v-slot="{ errors }"
    rules="required"
    mode="eager"
    :name="tag.description"
  >
    <date-time-field
      :id="`form-date-field-${tag.name}`"
      v-model="formData"
      :label="tag.description"
      format="dd.MM.yyyy"
      outlined
      dense
      :error-messages="errors"
      :readonly="readonly"
      @update:formattedDatetime="testAndEmitTitleChange"
    />
  </validation-provider>
</template>

<script>
import { computed } from "vue";
import DateTimeField from "@/components/DatetimeField.vue";

export default {
  components: {
    DateTimeField
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    testAndEmitTitleChange(val) {
      if (this.tag.name == "title" && val !== null) {
        this.$emit("title-change", `dt-${val}`);
      }
    }
  },

  setup(props, { emit }) {
    const formData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    return {
      formData
    };
  }
};
</script>
